import BaseModelAPI from '../BaseModelAPI';

export default class ReceiptFromProduction extends BaseModelAPI {
	static entity = 'receiptfromproduction';
	static entityName = 'receiptfromproduction';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.workOrderProcessDetailId = '';
			this.workOrderProcessDetail = {};
			this.documentStatusId = '';
			this.documentStatus = {};
			this.receiptFromProductionMaterial = []
			this.receiptFromProductionCase = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}